import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { sendOtp, verifyOtp } from '../services/userService';
import { getLoginNumbers } from '../api/apiConfig';
import '../style/LandingPage.css';
import tick from '../assets/tick.png';
import logo2 from '../assets/logo2.png';
import tlogo from '../assets/tlogo.png';

const LandingPage = () => {
  const [mobile, setMobile] = useState('');
  const [otp, setOtp] = useState('');
  const [message, setMessage] = useState('');
  const [isOtpSent, setIsOtpSent] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [error, setError] = useState(false);
  const [transitionClass, setTransitionClass] = useState('visible');
  const [timer, setTimer] = useState(30); // Timer starts at 30 seconds
  

  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem('token');
    // const kycStatus = localStorage.getItem('kyc_status');

    const loginTime = localStorage.getItem('loginTime');
    const loginDate = new Date(loginTime);
    const currentDate = new Date();
    const diffInMilliseconds = currentDate - loginDate;

    // Step 5: Convert milliseconds to minutes
    const diffInMinutes = Math.floor(diffInMilliseconds / 60000);


    if (!!token && diffInMinutes < 60*24*20) {
      navigate('/sales');
    }
  }, [navigate]);

  // Start the timer when OTP view is displayed
  useEffect(() => {
    let countdown;
    if (isOtpSent && timer > 0) {
      countdown = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else if (timer === 0) {
      clearInterval(countdown); // Clear the interval when the timer reaches zero
    }
    return () => clearInterval(countdown); // Cleanup the interval on unmount
  }, [isOtpSent, timer]);

  const handleSendOtp = async (event) => {
    event.preventDefault();
    if (mobile.length !== 10) {
      setError(true);
      setMessage('Enter a valid mobile number');
      return;
    }

    setMessage('Checking authorization...');
    const allowedNumbers = await getLoginNumbers();
    if (!allowedNumbers.includes(mobile)) {
      setError(true);
      setMessage('This phone number is not authorized to access the system');
      return;
    }

    setError(false);

    try {
      setTransitionClass('hidden');
      setTimeout(() => {
        setTransitionClass('visible');
        setIsOtpSent(true);
      }, 500);
      
      const response = await sendOtp({ number: mobile });
      setMessage(`OTP sent: ${response.message || 'Success'}`);
      setTimer(30); // Reset timer to 30 seconds
    } catch (error) {
      setMessage('Failed to send OTP. Please try again.');
    }
  };

  const handleVerifyOtp = async (event) => {
    event.preventDefault();
    try {
      const response = await verifyOtp({ number: mobile, otp });
      setMessage(`OTP verified: ${response.message || 'Success'}`);
      if (response.data) {
        
        const { token, profile_id, user_id, authorization, kyc_status, auth_expiry} = response.data;
        localStorage.setItem('token', token);
        localStorage.setItem('profile_id', profile_id);
        localStorage.setItem('number', mobile);
        const loginTime = new Date().toISOString();
        localStorage.setItem('loginTime', loginTime);
        localStorage.setItem('authorization', authorization);
        localStorage.setItem('user_id', user_id);
        localStorage.setItem('kyc_status', kyc_status);
        localStorage.setItem('auth_expiry', auth_expiry);
        localStorage.setItem('ddpi', false);
        // const response2 = await getOptionbaseDetails({ number: mobile });
        // if (response2.data && response2.data != null){
        //   const { UserID, Authorization, KycStatus, AccessExpiry} = response2.data;
        //   localStorage.setItem('authorization', Authorization);
        //   localStorage.setItem('user_id', UserID);
        //   localStorage.setItem('kyc_status', KycStatus);
        //   localStorage.setItem('auth_expiry', AccessExpiry);
        //   localStorage.setItem('number', mobile);
        //   const loginTime = new Date().toISOString();
        //   localStorage.setItem('loginTime', loginTime);
        // }else{
        //   localStorage.setItem('authorization', authorization);
        //   localStorage.setItem('user_id', user_id);
        //   localStorage.setItem('kyc_status', kyc_status);
        //   localStorage.setItem('auth_expiry', auth_expiry);
        //   localStorage.setItem('number', mobile);
        //   const loginTime = new Date().toISOString();
        //   localStorage.setItem('loginTime', loginTime);
        // }
        
        navigate('/sales');
      }
    } catch (error) {
      setMessage('Failed to verify OTP. Please try again.');
    }
  };

  const handleResendOtp = async () => {
    try {
      const response = await sendOtp({ number: mobile });
      setMessage(`OTP resent: ${response.message || 'Success'}`);
      setTimer(30); // Restart the timer
    } catch (error) {
      setMessage('Failed to resend OTP. Please try again.');
    }
  };

  const handleEditNumber = () => {
    setIsOtpSent(false); // Reset OTP view
    setOtp(''); // Clear OTP input
    setMessage(''); // Clear any messages
  };

  return (
    <div className="landing-container">
      <div className="login-section">
        <div className="logo-login">
          <img src={logo2} alt="Sales - Returns.trade Logo" className="logo-login-image" />
          <img src={tlogo} alt="Sales - Returns.trade" className="logo-login-image-title" />
        </div>
        <div className='login-main-section'>
          {isOtpSent ? (
            <div className={`otp-section ${transitionClass}`}>
              <h2>Enter OTP</h2>
              <label className={`input-label ${isFocused || otp ? 'focused' : ''}`}>
                Enter the OTP sent to {mobile}
              </label>
              <input
                type="text"
                placeholder="Enter OTP here"
                className={`input-field ${error ? 'error' : ''}`}
                value={otp}
                maxLength="6"
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setOtp(value);
                }}
                required
              />
              {error && <p className="message">{message}</p>}
              <div className="otp-buttons">
                <button
                  className="verify-otp-button"
                  onClick={handleVerifyOtp}
                >
                  Verify OTP
                </button>
                <button
                  className="edit-number-button"
                  onClick={handleEditNumber}
                >
                  Edit Number
                </button>
              </div>
              <div className="resend-otp">
                {timer > 0 ? (
                  <p>Resend OTP in {timer}s</p>
                ) : (
                  <button onClick={handleResendOtp}>Resend OTP</button>
                )}
              </div>
            </div>
          ) : (
            <div className={`phone-section ${transitionClass}`}>
              <h2>Log in</h2>
              <label className={`input-label ${isFocused || mobile ? 'focused' : ''}`}>
                Enter your Phone number
              </label>
              <input
                type="tel"
                placeholder="Enter number here"
                className={`input-field ${error ? 'error' : ''}`}
                value={mobile}
                maxLength="10"
                onFocus={() => setIsFocused(true)}
                onBlur={() => setIsFocused(false)}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, '');
                  setMobile(value);
                  if (value.length === 10) setError(false);
                }}
                required
              />
              {error && <p className="message">{message}</p>}
              <button
                className="send-otp-button"
                onClick={handleSendOtp}
              >
                Send OTP
              </button>
            </div>
          )}
          <div className="sebi-info">
            <img alt="certified" src={tick} className='tick-icon'></img>
            <span>SEBI RA reg number: <span>INH000014492</span></span>
          </div>
          <p className="footer-text">
            © 2024 Sales - Returns.trade. All Rights Reserved.
          </p>
        </div>
      </div>
      
    </div>
  );
};

export default LandingPage;
